// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import * as VueGoogleMaps from 'vue2-google-maps';
import Vuex from 'vuex'
import store from './store/store'
import VueRouterMultiView from 'vue-router-multi-view'
import Ads from 'vue-google-adsense'





Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyARHWwR3iZh_eHymkjinF5hPX9bnTOcc0w',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  }
});
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  template: '<App/>'
})

Vue.use(BootstrapVue);
Vue.use(Vuex)
Vue.use(VueRouterMultiView)
Vue.use(require('vue-script2'))
Vue.use(Ads.Adsense)
Vue.use(Ads.InArticleAdsense)
Vue.use(Ads.InFeedAdsense)






// WEBPACK FOOTER //
// ./src/main.js